import type { Video } from "@/types/video";

interface VideoPlayerProps {
  video: Video;
  onNotify: (message: string) => void;
}

export default function VideoPlayer({ video, onNotify }: VideoPlayerProps) {
  return (
    <div className="relative aspect-video w-full overflow-hidden rounded-lg bg-foreground-950">
      <img
        src={video.cover}
        alt={video.title}
        title={`${video.title} - 逼特逼视频`}
        className="h-full w-full object-cover opacity-60"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-transparent to-foreground-950/30" />

      <span className="absolute left-3 top-3 flex items-center gap-1.5 rounded-full bg-foreground-950/70 px-3 py-1 text-xs text-background-100 backdrop-blur">
        <i className="ri-error-warning-line text-accent-400" />
        演示预览 · 暂不支持真实播放
      </span>

      <button
        type="button"
        onClick={() => onNotify("当前为演示模式，暂不支持真实播放")}
        aria-label="播放"
        className="absolute left-1/2 top-1/2 flex h-16 w-16 -translate-x-1/2 -translate-y-1/2 cursor-pointer items-center justify-center rounded-full bg-primary-500/90 text-background-50 transition-transform duration-300 hover:scale-110"
      >
        <i className="ri-play-fill text-3xl" />
      </button>

      <div className="absolute bottom-0 left-0 right-0 px-4 pb-3 pt-6">
        <div className="mb-2 h-1 w-full overflow-hidden rounded-full bg-background-50/25">
          <div className="h-full w-1/3 rounded-full bg-accent-500" />
        </div>
        <div className="flex items-center justify-between text-xs text-background-100">
          <div className="flex items-center gap-4">
            <button
              type="button"
              onClick={() => onNotify("当前为演示模式，暂不支持真实播放")}
              className="cursor-pointer transition-colors hover:text-accent-400"
              aria-label="播放/暂停"
            >
              <i className="ri-play-circle-line text-lg" />
            </button>
            <button
              type="button"
              onClick={() => onNotify("音量为演示控件，暂不可调节")}
              className="cursor-pointer transition-colors hover:text-accent-400"
              aria-label="音量"
            >
              <i className="ri-volume-up-line text-lg" />
            </button>
            <span className="font-label">03:12 / {video.duration}</span>
          </div>
          <div className="flex items-center gap-4">
            <button
              type="button"
              onClick={() => onNotify("清晰度切换为演示控件")}
              className="cursor-pointer transition-colors hover:text-accent-400"
              aria-label="清晰度"
            >
              <i className="ri-hd-line text-lg" />
            </button>
            <button
              type="button"
              onClick={() => onNotify("全屏功能为演示控件")}
              className="cursor-pointer transition-colors hover:text-accent-400"
              aria-label="全屏"
            >
              <i className="ri-fullscreen-line text-lg" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}